import type { ImageProps } from 'react-native'
import { Icon } from '~/components/icon'
import * as C from './product-header-image.styles'

export function ProductHeaderImage(props: ImageProps) {
  return props.source ? (
    <C.Image {...props} />
  ) : (
    <C.NoImage testID={props.testID}>
      <Icon
        size="extra-small"
        symbol="rdicon-image"
        color="colorTextNeutralReadonly"
      />
    </C.NoImage>
  )
}
